import config from './config';

export const getCookie = (name) => {
    const cookieEntries = String(document.cookie ?? '')
        .split(';')
        .map((entry) => entry.trim())
        .filter(Boolean);
    let matchedValue;

    cookieEntries.forEach((entry) => {
        const separatorIndex = entry.indexOf('=');
        const entryName = separatorIndex >= 0 ? entry.slice(0, separatorIndex) : entry;

        if (entryName === name) {
            matchedValue = separatorIndex >= 0 ? entry.slice(separatorIndex + 1) : '';
        }
    });

    return matchedValue;
};

const CRATE_COOKIE_DOMAINS = [
    'productioncrate.com',
    'footagecrate.com',
    'soundscrate.com',
    'rendercrate.com',
    'graphicscrate.com',
];

export const getCookieDomain = (hostname = window.location.hostname) => {
    if (config.cookieDomain) {
        return config.cookieDomain;
    }

    if (getEnvironment() === 'development') {
        return 'localhost';
    }

    const normalizedHostname = String(hostname ?? '').trim().toLowerCase();
    const matchingDomain = CRATE_COOKIE_DOMAINS.find((domain) => (
        normalizedHostname === domain || normalizedHostname.endsWith(`.${domain}`)
    ));

    return matchingDomain ? `.${matchingDomain}` : null;
};

export const deleteCookie = (name, domain = false) => {
    const expireCookie = (cookieDomain) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`
            + (cookieDomain ? `; domain=${cookieDomain}` : '');
    };

    if (!domain) {
        expireCookie(undefined);
        const cookieDomain = getCookieDomain();
        if (cookieDomain) {
            expireCookie(cookieDomain);
        }

        return;
    }

    expireCookie(domain);
};

export const setCookie = (name, value, days, domain = false) => {
    if (domain === false) {
        domain = getCookieDomain();
    }
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    // Seteando Secure y SameSite=None si no estamos en localhost (porque requiere HTTPS)
    let secure = "";
    let sameSite = "";
    if (domain !== "localhost") {
        secure = "; Secure";
        sameSite = "; SameSite=None";
    }
    // Setear la cookie con los atributos adicionales
    document.cookie = name + "=" + (value || "") + expires + "; path=/" + 
                      (domain ? "; domain=" + domain : "") + sameSite + secure;
};


export const getPersistedValue = (localStorageKey, cookieKey, requestValue) => {
    //DEPRACATED LOCALSTORAGE
    //let localStorageValue = localStorage.getItem(localStorageKey);
    let cookieValue = getCookie(cookieKey);

    //console.debug("get persisted value", localStorageKey, cookieKey, localStorageValue === cookieValue);

    if(requestValue){
        //console.debug("Request value", requestValue);
        setPersistedValue(localStorageKey, cookieKey, requestValue);
        return requestValue;
    }

    return cookieValue;

    /*
    //DEPRACATED LOCALSTORAGE
    if(cookieValue && cookieValue != localStorageValue){
        //console.debug("Persisted values differences (wrong localstorage)");
        setPersistedValue(localStorageKey, cookieKey, cookieValue);
        return cookieValue;
    }

    if(localStorageValue && cookieValue != localStorageValue){
        //console.debug("Persisted values differences (wrong/no cookie)");
        setPersistedValue(localStorageKey, cookieKey, localStorageValue);
        return localStorageValue;
    }

    return localStorageValue || cookieValue;
    */
};

export const setPersistedValue = (localStorageKey, cookieKey, value) => {
    if(!value){
        //console.log("Got a falsy value for "+localStorageKey+"/"+cookieKey+" removing...");
        //DEPRACATED LOCALSTORAGE
        //localStorage.removeItem(localStorageKey);
        deleteCookie(cookieKey);
        return;
    }
    //console.debug("Persisting value in ",localStorageKey, cookieKey);
    //DEPRACATED LOCALSTORAGE
    //localStorage.setItem(localStorageKey, value);
    setCookie(cookieKey, value, 365);
};


export const getReadableDate = (timestring) => {
    let date = new Date(timestring);

    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
}

export const getEnvironment = () => {
    const hostname = window.location.hostname || '';
    const isLocal = hostname === 'localhost'
        || hostname === '127.0.0.1'
        || hostname.endsWith('.localhost');

    if (isLocal) {
        return 'development';
    }

    if (hostname.includes('user-qa') || hostname.includes('staging')) {
        return 'qa';
    }

    return 'production';
};
